'use strict';

exports.__esModule = true;
exports.uploadApprovalLetterFail = exports.uploadApprovalLetterSuccess = exports.uploadApprovalLetter = exports.resetApprovalLetter = exports.fetchApprovalLetterFail = exports.fetchApprovalLetterSuccess = exports.fetchApprovalLetter = exports.uploadNationalIdFail = exports.uploadNationalIdSuccess = exports.uploadNationalId = exports.fetchPatientInsuranceCardFail = exports.fetchPatientInsuranceCardSuccess = exports.fetchPatientInsuranceCard = exports.resetNationalId = exports.fetchNationalIdFail = exports.fetchNationalIdSuccess = exports.fetchNationalId = exports.toggleConfirmationModal = exports.addPrescriptionFail = exports.addPrescriptionSuccess = exports.addPrescription = exports.setSnackBarAsHidden = exports.toggleRescheduleModal = exports.toggleAddPrescriptionModal = exports.setRescheduleAppointmentDetailsModal = exports.setAddPrescriptionDetailsModal = exports.toggleAddAppointmentModal = exports.setMarkAsInsuredAppointmentDetailsModal = exports.toggleMarkAsInsuredAppointmentModal = exports.setMarkAsNoShowAppointmentDetailsModal = exports.toggleMarkAsNoShowAppointmentModal = exports.setEditAppointmentDetailsModal = exports.setCancelAppointmentDetailsModal = exports.setPrintInvoiceDetailsModal = exports.togglePrintInvoiceModal = exports.toggleEditAppointmentModal = exports.toggleCancelAppointmentModal = exports.setSelectedPatientKey = exports.setSelectedRoomsAndDoctors = exports.setSelectedDates = exports.cancelFail = exports.cancelSuccess = exports.cancel = exports.checkInFail = exports.checkInSuccess = exports.checkIn = exports.markAsInsuredFail = exports.markAsInsuredSuccess = exports.markAsInsured = exports.markAsNoShowFail = exports.markAsNoShowSuccess = exports.markAsNoShow = exports.createAppointmentFail = exports.createAppointmentSuccess = exports.createAppointment = exports.closeAppointmentsNotificationBar = exports.loadAppointmentsUpdates = exports.fetchAppointmentsUpdatesFail = exports.fetchAppointmentsUpdatesSuccess = exports.fetchAppointmentsUpdates = exports.fetchAppointmentsFail = exports.fetchAppointmentsSuccess = exports.fetchAppointments = exports.submitEditAppointmentFailed = exports.submitEditAppointmentSuccess = exports.submitEditAppointment = exports.addAppointmentFailed = exports.addAppointmentSuccess = exports.addAppointment = exports.getAppointmentInvoiceFailed = exports.getAppointmentInvoiceSuccess = exports.getAppointmentInvoice = exports.getReservationCountFailed = exports.getReservationCountSuccess = exports.getReservationCount = exports.APPOINTMENTS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Constants = require('@vezeeta/enterprise-utils/lib/Constants');

var APPOINTMENTS = exports.APPOINTMENTS = {
  FETCH_COUNT_RESERVATION: {
    LOAD: 'COUNT_RESERVATION_FETCH',
    SUCCESS: 'COUNT_RESERVATION_SUCCESS',
    FAIL: 'COUNT_RESERVATION_FAIL'
  },
  FETCH: {
    LOAD: 'APPOINTMENTS_FETCH',
    SUCCESS: 'APPOINTMENTS_FETCH_SUCCESS',
    FAIL: 'APPOINTMENTS_FETCH_FAIL'
  },
  FETCH_UPDATES: {
    LOAD: 'APPOINTMENTS_FETCH_UPDATES',
    SUCCESS: 'APPOINTMENTS_FETCH_SUCCESS_UPDATES',
    FAIL: 'APPOINTMENTS_FETCH_FAIL_UPDATES'
  },
  LOAD_APPOINTMENTS_UPDATES: 'LOAD_APPOINTMENTS_UPDATES',
  CLOSE_APPOINTMENTS_NOTIFICATION_BAR: 'CLOSE_APPOINTMENTS_NOTIFICATION_BAR',
  FETCH_MORE: {
    LOAD: 'FETCH_MORE',
    SUCCESS: 'FETCH_MORE_SUCCESS',
    FAIL: 'FETCH_MORE_FAIL'
  },
  CREATE: {
    LOAD: 'APPOINTMENTS_CREATE',
    SUCCESS: 'APPOINTMENTS_CREATE_SUCCESS',
    FAIL: 'APPOINTMENTS_CREATE_FAIL'
  },
  MARK_AS_NO_SHOW: {
    LOAD: 'APPOINTMENTS_MARK_AS_NO_SHOW',
    SUCCESS: 'APPOINTMENTS_MARK_AS_NO_SHOW_SUCCESS',
    FAIL: 'APPOINTMENTS_MARK_AS_NO_SHOW_FAIL'
  },
  MARK_AS_INSURED: {
    LOAD: 'APPOINTMENTS_MARK_AS_INSURED',
    SUCCESS: 'APPOINTMENTS_MARK_AS_INSURED_SUCCESS',
    FAIL: 'APPOINTMENTS_MARK_AS_INSURED_FAIL'
  },
  CHECK_IN: {
    LOAD: 'APPOINTMENTS_CHECK_IN',
    SUCCESS: 'APPOINTMENTS_CHECK_IN_SUCCESS',
    FAIL: 'APPOINTMENTS_CHECK_IN_FAIL'
  },
  CANCEL: {
    LOAD: 'APPOINTMENTS_CANCEL',
    SUCCESS: 'APPOINTMENTS_CANCEL_SUCCESS',
    FAIL: 'APPOINTMENTS_CANCEL_FAIL'
  },
  FILTER: {
    SET_SELECTED_DATES: 'APPOINTMENTS_FILTER_SET_SELECTED_DATES',
    SET_SELECTED_ROOMS_AND_DOCTORS: 'APPOINTMENTS_FILTER_SET_SELECTED_ROOMS_AND_DOCTORS',
    SET_PATIENT_NAME: 'SET_PATIENT_NAME'
  },
  MODAL: {
    CANCEL_TOGGLE: 'APPOINTMENTS_MODAL_CANCEL_TOGGLE',
    SET_CANCEL_APPOINTMENT_DETAILS: 'APPOINTMENTS_MODAL_SET_CANCEL_APPOINTMENT_DETAILS',
    NO_SHOW_TOGGLE: 'APPOINTMENTS_MODAL_NO_SHOW_TOGGLE',
    SET_NO_SHOW_APPOINTMENT_DETAILS: 'APPOINTMENTS_MODAL_SET_NO_SHOW_APPOINTMENT_DETAILS',
    INSURED_TOGGLE: 'APPOINTMENTS_MODAL_INSURED_TOGGLE',
    SET_INSURED_APPOINTMENT_DETAILS: 'APPOINTMENTS_MODAL_SET_INSURED_APPOINTMENT_DETAILS',
    ADD_APPOINTMENT_TOGGLE: 'APPOINTMENTS_MODAL_ADD_APPOINTMENT_TOGGLE',
    SET_PRESCRIPTION_APPOINTMENT_DETAILS: 'SET_PRESCRIPTION_APPOINTMENT_DETAILS',
    SET_RESCHEDULE_APPOINTMENT_DETAILS: 'SET_RESCHEDULE_APPOINTMENT_DETAILS',
    ADD_PRESCRIPTION_TOGGLE: 'ADD_PRESCRIPTION_MODAL_TOGGLE',
    CONFIRMATION: 'CONFIRMATION_MODAL_TOGGLE',
    RESCHEDULE_TOGGLE: 'RESCHEDULE_TOGGLE',
    EDIT_APPOINTMENT: 'EDIT_APPOINTMENT',
    EDIT_APPOINTMENT_TOGGLE: 'EDIT_APPOINTMENT_TOGGLE',
    PRINT_INVOICE_TOGGLE: 'PRINT_INVOICE_TOGGLE',
    SET_PRINT_INVOICE_DETAILS: 'SET_PRINT_INVOICE_DETAILS'
  },
  SNACK_BAR: {
    HIDE: 'APPOINTMENTS_SNACK_BAR_HIDE'
  },
  ADD_PRESCRIPTION: {
    LOAD: 'ADD_PRESCRIPTION',
    SUCCESS: 'ADD_PRESCRIPTION_SUCCESS',
    FAIL: 'ADD_PRESCRIPTION_FAIL'
  },
  ADD_APPOINTMENT: {
    SUBMIT: 'ADD_APPOINTMENT',
    SUCCESS: 'ADD_APPOINTMENT_SUCCESS',
    FAILED: 'ADD_APPOINTMENT_FAILED'
  },
  EDIT_APPOINTMENT: {
    SUBMIT: 'SUBMIT_EDIT_APPOINTMENT',
    SUCCESS: 'SUBMIT_EDIT_APPOINTMENT_SUCCESS',
    FAILED: 'SUBMIT_EDIT_APPOINTMENT_FAILED'
  },
  NATIONAL_ID: {
    LOAD: 'NATIONAL_ID_FETCH',
    SUCCESS: 'NATIONAL_ID_FETCH_SUCCESS',
    FAIL: 'NATIONAL_ID_FETCH_FAIL',
    RESET: 'NATIONAL_ID_RESET'
  },
  GET_APPOINTMENT_INVOICE: {
    LOAD: 'GET_APPOINTMENT_INVOICE_FETCH',
    SUCCESS: 'GET_APPOINTMENT_INVOICE_SUCCESS',
    FAIL: 'GET_APPOINTMENT_INVOICE_FAIL'
  },
  INSURANCE_CARD: {
    LOAD: 'INSURANCE_CARD_FETCH',
    SUCCESS: 'INSURANCE_CARD_FETCH_SUCCESS',
    FAIL: 'INSURANCE_CARD_FETCH_FAIL'
  },
  UPLOAD_NATIONAL_ID: {
    LOAD: 'UPLOAD_NATIONAL_ID',
    SUCCESS: 'UPLOAD_NATIONAL_ID_SUCCESS',
    FAIL: 'NUPLOAD_NATIONAL_ID_FAIL'
  },
  APPROVAL_LETTER: {
    LOAD: 'APPROVAL_LETTER_FETCH',
    SUCCESS: 'APPROVAL_LETTER_FETCH_SUCCESS',
    FAIL: 'APPROVAL_LETTER_FETCH_FAIL',
    RESET: 'APPROVAL_LETTER_RESET'
  },
  UPLOAD_APPROVAL_LETTER: {
    LOAD: 'UPLOAD_APPROVAL_LETTER',
    SUCCESS: 'UPLOAD_APPROVAL_LETTER_SUCCESS',
    FAIL: 'NUPLOAD_APPROVAL_LETTER_FAIL'
  }
};

var getReservationCount = exports.getReservationCount = function getReservationCount(payload) {
  return {
    type: APPOINTMENTS.FETCH_COUNT_RESERVATION.LOAD,
    payload: payload
  };
};

var getReservationCountSuccess = exports.getReservationCountSuccess = function getReservationCountSuccess(payload) {
  return {
    type: APPOINTMENTS.FETCH_COUNT_RESERVATION.SUCCESS,
    payload: payload
  };
};

var getReservationCountFailed = exports.getReservationCountFailed = function getReservationCountFailed(payload) {
  return {
    type: APPOINTMENTS.FETCH_COUNT_RESERVATION.FAIL,
    payload: payload
  };
};

var getAppointmentInvoice = exports.getAppointmentInvoice = function getAppointmentInvoice(payload) {
  return {
    type: APPOINTMENTS.GET_APPOINTMENT_INVOICE.LOAD,
    payload: payload
  };
};

var getAppointmentInvoiceSuccess = exports.getAppointmentInvoiceSuccess = function getAppointmentInvoiceSuccess(payload) {
  return {
    type: APPOINTMENTS.GET_APPOINTMENT_INVOICE.SUCCESS,
    payload: payload
  };
};

var getAppointmentInvoiceFailed = exports.getAppointmentInvoiceFailed = function getAppointmentInvoiceFailed(payload) {
  return {
    type: APPOINTMENTS.GET_APPOINTMENT_INVOICE.FAIL,
    payload: payload
  };
};

var addAppointment = exports.addAppointment = function addAppointment(payload) {
  return {
    type: APPOINTMENTS.ADD_APPOINTMENT.SUBMIT,
    payload: payload
  };
};

var addAppointmentSuccess = exports.addAppointmentSuccess = function addAppointmentSuccess(payload) {
  return {
    type: APPOINTMENTS.ADD_APPOINTMENT.SUCCESS,
    payload: payload
  };
};

var addAppointmentFailed = exports.addAppointmentFailed = function addAppointmentFailed() {
  return {
    type: APPOINTMENTS.ADD_APPOINTMENT.FAILED
  };
};

var submitEditAppointment = exports.submitEditAppointment = function submitEditAppointment(payload) {
  return {
    type: APPOINTMENTS.EDIT_APPOINTMENT.SUBMIT,
    payload: payload
  };
};

var submitEditAppointmentSuccess = exports.submitEditAppointmentSuccess = function submitEditAppointmentSuccess(payload) {
  return {
    type: APPOINTMENTS.EDIT_APPOINTMENT.SUCCESS,
    payload: payload
  };
};

var submitEditAppointmentFailed = exports.submitEditAppointmentFailed = function submitEditAppointmentFailed() {
  return {
    type: APPOINTMENTS.EDIT_APPOINTMENT.FAILED
  };
};

var fetchAppointments = exports.fetchAppointments = function fetchAppointments(roomsNames, doctorsNames, doctors, startDate, endDate, patientKey) {
  var pushToCurrent = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var pageNumber = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
  var newAppointment = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
  return {
    type: APPOINTMENTS.FETCH.LOAD,
    roomsNames: roomsNames,
    doctorsNames: doctorsNames,
    doctors: doctors,
    startDate: startDate,
    endDate: endDate,
    patientKey: patientKey,
    pushToCurrent: pushToCurrent,
    pageNumber: pageNumber,
    newAppointment: newAppointment
  };
};

var fetchAppointmentsSuccess = exports.fetchAppointmentsSuccess = function fetchAppointmentsSuccess(appointments, pushToCurrent) {
  return {
    type: APPOINTMENTS.FETCH.SUCCESS,
    appointments: appointments,
    pushToCurrent: pushToCurrent
  };
};

var fetchAppointmentsFail = exports.fetchAppointmentsFail = function fetchAppointmentsFail() {
  return {
    type: APPOINTMENTS.FETCH.FAIL
  };
};

var fetchAppointmentsUpdates = exports.fetchAppointmentsUpdates = function fetchAppointmentsUpdates(roomsNames, doctorsNames, doctors, startDate, endDate, patientKey) {
  var pushToCurrent = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var pageNumber = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
  var newAppointment = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
  var pageSize = arguments[9];
  return {
    type: APPOINTMENTS.FETCH_UPDATES.LOAD,
    roomsNames: roomsNames,
    doctorsNames: doctorsNames,
    doctors: doctors,
    startDate: startDate,
    endDate: endDate,
    patientKey: patientKey,
    pushToCurrent: pushToCurrent,
    pageNumber: pageNumber,
    newAppointment: newAppointment,
    pageSize: pageSize
  };
};

var fetchAppointmentsUpdatesSuccess = exports.fetchAppointmentsUpdatesSuccess = function fetchAppointmentsUpdatesSuccess(appointments, pushToCurrent) {
  return {
    type: APPOINTMENTS.FETCH_UPDATES.SUCCESS,
    appointments: appointments,
    pushToCurrent: pushToCurrent
  };
};

var fetchAppointmentsUpdatesFail = exports.fetchAppointmentsUpdatesFail = function fetchAppointmentsUpdatesFail() {
  return {
    type: APPOINTMENTS.FETCH_UPDATES.FAIL
  };
};

var loadAppointmentsUpdates = exports.loadAppointmentsUpdates = function loadAppointmentsUpdates() {
  return {
    type: APPOINTMENTS.LOAD_APPOINTMENTS_UPDATES
  };
};

var closeAppointmentsNotificationBar = exports.closeAppointmentsNotificationBar = function closeAppointmentsNotificationBar() {
  return {
    type: APPOINTMENTS.CLOSE_APPOINTMENTS_NOTIFICATION_BAR
  };
};

var createAppointment = exports.createAppointment = function createAppointment(appointment, patient, roomsNames, doctorsNames, callback) {
  for (var _len = arguments.length, callbackParams = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
    callbackParams[_key - 5] = arguments[_key];
  }

  return _extends({
    type: APPOINTMENTS.CREATE.LOAD,
    appointment: appointment,
    patient: patient,
    roomsNames: roomsNames,
    doctorsNames: doctorsNames,
    callback: callback
  }, callbackParams);
};

var createAppointmentSuccess = exports.createAppointmentSuccess = function createAppointmentSuccess(appointment) {
  return {
    type: APPOINTMENTS.CREATE.SUCCESS,
    appointment: appointment
  };
};

var createAppointmentFail = exports.createAppointmentFail = function createAppointmentFail() {
  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Constants.DEFAULT_ERROR_MESSAGE;
  return {
    type: APPOINTMENTS.CREATE.FAIL,
    error: error
  };
};

var markAsNoShow = exports.markAsNoShow = function markAsNoShow(appointmentKey, accountKey, roomKey, isNoShow, sendSMS) {
  return {
    type: APPOINTMENTS.MARK_AS_NO_SHOW.LOAD,
    appointmentKey: appointmentKey,
    accountKey: accountKey,
    roomKey: roomKey,
    isNoShow: isNoShow,
    sendSMS: sendSMS
  };
};

var markAsNoShowSuccess = exports.markAsNoShowSuccess = function markAsNoShowSuccess(appointmentKey, isNoShow) {
  return {
    type: APPOINTMENTS.MARK_AS_NO_SHOW.SUCCESS,
    appointmentKey: appointmentKey,
    isNoShow: isNoShow
  };
};

var markAsNoShowFail = exports.markAsNoShowFail = function markAsNoShowFail(appointmentKey) {
  return {
    type: APPOINTMENTS.MARK_AS_NO_SHOW.FAIL,
    appointmentKey: appointmentKey
  };
};

var markAsInsured = exports.markAsInsured = function markAsInsured(appointmentKey, accountKey, roomKey, isInsured) {
  return {
    type: APPOINTMENTS.MARK_AS_INSURED.LOAD,
    appointmentKey: appointmentKey,
    accountKey: accountKey,
    roomKey: roomKey,
    isInsured: isInsured
  };
};

var markAsInsuredSuccess = exports.markAsInsuredSuccess = function markAsInsuredSuccess(appointmentKey, isInsured) {
  return {
    type: APPOINTMENTS.MARK_AS_INSURED.SUCCESS,
    appointmentKey: appointmentKey,
    isInsured: isInsured
  };
};

var markAsInsuredFail = exports.markAsInsuredFail = function markAsInsuredFail(appointmentKey) {
  return {
    type: APPOINTMENTS.MARK_AS_INSURED.FAIL,
    appointmentKey: appointmentKey
  };
};

var checkIn = exports.checkIn = function checkIn(appointmentKey, accountKey, roomKey, isCheckedIn) {
  return {
    type: APPOINTMENTS.CHECK_IN.LOAD,
    appointmentKey: appointmentKey,
    accountKey: accountKey,
    roomKey: roomKey,
    isCheckedIn: isCheckedIn
  };
};

var checkInSuccess = exports.checkInSuccess = function checkInSuccess(appointmentKey, isCheckedIn) {
  return {
    type: APPOINTMENTS.CHECK_IN.SUCCESS,
    appointmentKey: appointmentKey,
    isCheckedIn: isCheckedIn
  };
};

var checkInFail = exports.checkInFail = function checkInFail(appointmentKey) {
  return {
    type: APPOINTMENTS.CHECK_IN.FAIL,
    appointmentKey: appointmentKey
  };
};

var cancel = exports.cancel = function cancel(appointmentKey, accountKey, roomKey, sendSMS) {
  return {
    type: APPOINTMENTS.CANCEL.LOAD,
    appointmentKey: appointmentKey,
    accountKey: accountKey,
    roomKey: roomKey,
    sendSMS: sendSMS
  };
};

var cancelSuccess = exports.cancelSuccess = function cancelSuccess(appointmentKey) {
  return {
    type: APPOINTMENTS.CANCEL.SUCCESS,
    appointmentKey: appointmentKey
  };
};

var cancelFail = exports.cancelFail = function cancelFail(appointmentKey) {
  return {
    type: APPOINTMENTS.CANCEL.FAIL,
    appointmentKey: appointmentKey
  };
};

var setSelectedDates = exports.setSelectedDates = function setSelectedDates(dates) {
  return {
    type: APPOINTMENTS.FILTER.SET_SELECTED_DATES,
    dates: dates
  };
};

var setSelectedRoomsAndDoctors = exports.setSelectedRoomsAndDoctors = function setSelectedRoomsAndDoctors(roomsAndDoctors, hasDoctors) {
  return {
    type: APPOINTMENTS.FILTER.SET_SELECTED_ROOMS_AND_DOCTORS,
    roomsAndDoctors: roomsAndDoctors,
    hasDoctors: hasDoctors
  };
};

var setSelectedPatientKey = exports.setSelectedPatientKey = function setSelectedPatientKey(patientKey) {
  return {
    type: APPOINTMENTS.FILTER.SET_PATIENT_NAME,
    patientKey: patientKey
  };
};

var toggleCancelAppointmentModal = exports.toggleCancelAppointmentModal = function toggleCancelAppointmentModal(isOpened) {
  return {
    type: APPOINTMENTS.MODAL.CANCEL_TOGGLE,
    isOpened: isOpened
  };
};

var toggleEditAppointmentModal = exports.toggleEditAppointmentModal = function toggleEditAppointmentModal(isOpened) {
  return {
    type: APPOINTMENTS.MODAL.EDIT_APPOINTMENT_TOGGLE,
    isOpened: isOpened
  };
};

var togglePrintInvoiceModal = exports.togglePrintInvoiceModal = function togglePrintInvoiceModal(isOpened) {
  return {
    type: APPOINTMENTS.MODAL.PRINT_INVOICE_TOGGLE,
    isOpened: isOpened
  };
};

var setPrintInvoiceDetailsModal = exports.setPrintInvoiceDetailsModal = function setPrintInvoiceDetailsModal(payload) {
  return {
    type: APPOINTMENTS.MODAL.SET_PRINT_INVOICE_DETAILS,
    payload: payload
  };
};

var setCancelAppointmentDetailsModal = exports.setCancelAppointmentDetailsModal = function setCancelAppointmentDetailsModal(appointmentDetails) {
  return {
    type: APPOINTMENTS.MODAL.SET_CANCEL_APPOINTMENT_DETAILS,
    appointmentDetails: appointmentDetails
  };
};

var setEditAppointmentDetailsModal = exports.setEditAppointmentDetailsModal = function setEditAppointmentDetailsModal(appointmentDetails) {
  return {
    type: APPOINTMENTS.MODAL.EDIT_APPOINTMENT,
    appointmentDetails: appointmentDetails
  };
};

var toggleMarkAsNoShowAppointmentModal = exports.toggleMarkAsNoShowAppointmentModal = function toggleMarkAsNoShowAppointmentModal(isOpened) {
  return {
    type: APPOINTMENTS.MODAL.NO_SHOW_TOGGLE,
    isOpened: isOpened
  };
};

var setMarkAsNoShowAppointmentDetailsModal = exports.setMarkAsNoShowAppointmentDetailsModal = function setMarkAsNoShowAppointmentDetailsModal(appointmentDetails) {
  return {
    type: APPOINTMENTS.MODAL.SET_NO_SHOW_APPOINTMENT_DETAILS,
    appointmentDetails: appointmentDetails
  };
};

var toggleMarkAsInsuredAppointmentModal = exports.toggleMarkAsInsuredAppointmentModal = function toggleMarkAsInsuredAppointmentModal(isOpened) {
  return {
    type: APPOINTMENTS.MODAL.INSURED_TOGGLE,
    isOpened: isOpened
  };
};

var setMarkAsInsuredAppointmentDetailsModal = exports.setMarkAsInsuredAppointmentDetailsModal = function setMarkAsInsuredAppointmentDetailsModal(appointmentDetails) {
  return {
    type: APPOINTMENTS.MODAL.SET_INSURED_APPOINTMENT_DETAILS,
    appointmentDetails: appointmentDetails
  };
};

var toggleAddAppointmentModal = exports.toggleAddAppointmentModal = function toggleAddAppointmentModal(isOpened) {
  return {
    type: APPOINTMENTS.MODAL.ADD_APPOINTMENT_TOGGLE,
    isOpened: isOpened
  };
};

var setAddPrescriptionDetailsModal = exports.setAddPrescriptionDetailsModal = function setAddPrescriptionDetailsModal(appointmentDetails) {
  return {
    type: APPOINTMENTS.MODAL.SET_PRESCRIPTION_APPOINTMENT_DETAILS,
    appointmentDetails: appointmentDetails
  };
};

var setRescheduleAppointmentDetailsModal = exports.setRescheduleAppointmentDetailsModal = function setRescheduleAppointmentDetailsModal(appointmentDetails) {
  return {
    type: APPOINTMENTS.MODAL.SET_RESCHEDULE_APPOINTMENT_DETAILS,
    appointmentDetails: appointmentDetails
  };
};

var toggleAddPrescriptionModal = exports.toggleAddPrescriptionModal = function toggleAddPrescriptionModal(isOpened) {
  return {
    type: APPOINTMENTS.MODAL.ADD_PRESCRIPTION_TOGGLE,
    isOpened: isOpened
  };
};

var toggleRescheduleModal = exports.toggleRescheduleModal = function toggleRescheduleModal(isOpened) {
  return {
    type: APPOINTMENTS.MODAL.RESCHEDULE_TOGGLE,
    isOpened: isOpened
  };
};

var setSnackBarAsHidden = exports.setSnackBarAsHidden = function setSnackBarAsHidden() {
  return {
    type: APPOINTMENTS.SNACK_BAR.HIDE
  };
};

var addPrescription = exports.addPrescription = function addPrescription(reservationKey, prescriptionTypeId, prescriptionImages, successMassage, errorMassage, accountKey, insuranceKey, insuranceCardKey) {
  return {
    type: APPOINTMENTS.ADD_PRESCRIPTION.LOAD,
    reservationKey: reservationKey,
    prescriptionTypeId: prescriptionTypeId,
    prescriptionImages: prescriptionImages,
    successMassage: successMassage,
    errorMassage: errorMassage,
    accountKey: accountKey,
    insuranceKey: insuranceKey,
    insuranceCardKey: insuranceCardKey
  };
};

var addPrescriptionSuccess = exports.addPrescriptionSuccess = function addPrescriptionSuccess(appointmentKey, imagesCount, successMassage) {
  return {
    type: APPOINTMENTS.ADD_PRESCRIPTION.SUCCESS,
    appointmentKey: appointmentKey,
    imagesCount: imagesCount,
    successMassage: successMassage
  };
};

var addPrescriptionFail = exports.addPrescriptionFail = function addPrescriptionFail(errorMassage) {
  return {
    type: APPOINTMENTS.ADD_PRESCRIPTION.FAIL,
    errorMassage: errorMassage
  };
};

var toggleConfirmationModal = exports.toggleConfirmationModal = function toggleConfirmationModal(isOpened) {
  return {
    type: APPOINTMENTS.MODAL.CONFIRMATION,
    isOpened: isOpened
  };
};

var fetchNationalId = exports.fetchNationalId = function fetchNationalId(reservationKey) {
  return {
    type: APPOINTMENTS.NATIONAL_ID.LOAD,
    reservationKey: reservationKey
  };
};

var fetchNationalIdSuccess = exports.fetchNationalIdSuccess = function fetchNationalIdSuccess(data) {
  return {
    type: APPOINTMENTS.NATIONAL_ID.SUCCESS,
    data: data
  };
};

var fetchNationalIdFail = exports.fetchNationalIdFail = function fetchNationalIdFail(errorMassage) {
  return {
    type: APPOINTMENTS.NATIONAL_ID.FAIL,
    errorMassage: errorMassage
  };
};

var resetNationalId = exports.resetNationalId = function resetNationalId() {
  return {
    type: APPOINTMENTS.NATIONAL_ID.RESET
  };
};

var fetchPatientInsuranceCard = exports.fetchPatientInsuranceCard = function fetchPatientInsuranceCard(cardKey) {
  return {
    type: APPOINTMENTS.INSURANCE_CARD.LOAD,
    cardKey: cardKey
  };
};

var fetchPatientInsuranceCardSuccess = exports.fetchPatientInsuranceCardSuccess = function fetchPatientInsuranceCardSuccess(data) {
  return {
    type: APPOINTMENTS.INSURANCE_CARD.SUCCESS,
    data: data
  };
};

var fetchPatientInsuranceCardFail = exports.fetchPatientInsuranceCardFail = function fetchPatientInsuranceCardFail(errorMassage) {
  return {
    type: APPOINTMENTS.INSURANCE_CARD.FAIL,
    errorMassage: errorMassage
  };
};

var uploadNationalId = exports.uploadNationalId = function uploadNationalId(data) {
  return {
    type: APPOINTMENTS.UPLOAD_NATIONAL_ID.LOAD,
    data: data
  };
};

var uploadNationalIdSuccess = exports.uploadNationalIdSuccess = function uploadNationalIdSuccess(data) {
  return {
    type: APPOINTMENTS.UPLOAD_NATIONAL_ID.SUCCESS,
    data: data
  };
};

var uploadNationalIdFail = exports.uploadNationalIdFail = function uploadNationalIdFail(errorMassage) {
  return {
    type: APPOINTMENTS.UPLOAD_NATIONAL_ID.FAIL,
    errorMassage: errorMassage
  };
};

var fetchApprovalLetter = exports.fetchApprovalLetter = function fetchApprovalLetter(reservationKey) {
  return {
    type: APPOINTMENTS.APPROVAL_LETTER.LOAD,
    reservationKey: reservationKey
  };
};

var fetchApprovalLetterSuccess = exports.fetchApprovalLetterSuccess = function fetchApprovalLetterSuccess(data) {
  return {
    type: APPOINTMENTS.APPROVAL_LETTER.SUCCESS,
    data: data
  };
};

var fetchApprovalLetterFail = exports.fetchApprovalLetterFail = function fetchApprovalLetterFail(errorMassage) {
  return {
    type: APPOINTMENTS.APPROVAL_LETTER.FAIL,
    errorMassage: errorMassage
  };
};

var resetApprovalLetter = exports.resetApprovalLetter = function resetApprovalLetter() {
  return {
    type: APPOINTMENTS.APPROVAL_LETTER.RESET
  };
};

var uploadApprovalLetter = exports.uploadApprovalLetter = function uploadApprovalLetter(data) {
  return {
    type: APPOINTMENTS.UPLOAD_APPROVAL_LETTER.LOAD,
    data: data
  };
};

var uploadApprovalLetterSuccess = exports.uploadApprovalLetterSuccess = function uploadApprovalLetterSuccess(data) {
  return {
    type: APPOINTMENTS.UPLOAD_APPROVAL_LETTER.SUCCESS,
    data: data
  };
};

var uploadApprovalLetterFail = exports.uploadApprovalLetterFail = function uploadApprovalLetterFail(errorMassage) {
  return {
    type: APPOINTMENTS.UPLOAD_APPROVAL_LETTER.FAIL,
    errorMassage: errorMassage
  };
};